"use client"
import { Building2, UserCheck } from "lucide-react"
import { useAuth } from "../auth-provider"
import { Button } from "../ui/button"
import Link from "next/link"
import { useMessages, useTranslations } from "next-intl"
import { preload } from "react-dom"

const HERO_SRC = "/hero/hero-1920.webp"
const HERO_SRCSET = [640, 1280, 1920, 2560]
	.map((w) => `/hero/hero-${w}.webp ${w}w`)
	.join(", ")
const HERO_PLACEHOLDER =
	"data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAACwAwCdASoYAA4APu1iqU2ppaOiMAgBMB2JYwCo9Bw6lviebFUJAAD8f3osC+FtvP7Ehs5duPl0CKG0q3Qgw7E/kRGJuw3tskhznDglnNomWtGTEtEFb+JA5KKWMArmLGqPHHDs9EKLtgAA"

export default function Hero() {
	const user = useAuth()
	const t = useTranslations("home.hero")
	const messages = useMessages()

	preload(HERO_SRC, {
		as: "image",
		imageSrcSet: HERO_SRCSET,
		imageSizes: "100vw",
		fetchPriority: "high",
	})

	return (
		<section
			style={{ backgroundImage: `url(${HERO_PLACEHOLDER})` }}
			className="relative py-20 px-4 bg-[#99729a] bg-cover bg-center [clip-path:inset(0)]"
		>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img
				src={HERO_SRC}
				srcSet={HERO_SRCSET}
				sizes="100vw"
				alt=""
				aria-hidden
				fetchPriority="high"
				decoding="async"
				className="absolute inset-0 h-full w-full object-cover object-[55%_50%] md:fixed md:h-screen md:object-center"
			/>
			<div className="relative container mx-auto text-center text-white">
				<h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
					{t("title")}
					<span className="block">{t("subtitle")}</span>
				</h1>
				<p className="text-xl mb-8 mx-auto font-medium leading-relaxed">
					{t("description")}
				</p>
				{!user ? (
					<div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
						<Link href="/signup/employee">
							<Button size="xl">
								<UserCheck className="h-5 w-5" />
								{t("employee_signup")}
							</Button>
						</Link>

						<Link href="/signup/organization">
							<Button size="xl" variant="alternative">
								<Building2 className="h-5 w-5" />
								{t("organization_signup")}
							</Button>
						</Link>
					</div>
				) : null}
			</div>
		</section>
	)
}
